<template>
  <div>
    <HeaderPage href="/culture"/>
    <div class="neiBanner">
        <div class="textBanner wow " data-animate="fadeInUp">
            <dl>国正安全技术</dl>
            <dt>正念 / 正心 / 正言 / 正行</dt>
        </div>
    </div>
    <div class="culture">
        <div class="ntitle wow " data-animate="fadeInUp">
            <h3>COMPANY CULTURE</h3>
            <h2>公司文化</h2>
        </div>
        <div class="box">
            <div class="wrap flex flex-wrap">
                <div class="pic wow " data-animate="fadeInLeft">
                  <img src="@/assets/images/gHiSLo.jpg" alt="">
                </div>
                <div class="textBox wow flex align-center" data-animate="fadeInRight">
                    <ul>
                      <li>
                          <h3>企业经营理念</h3>
                          <dt><span style="white-space:normal;">正念 正心 正言 正行</span></dt>
                      </li>
                      <li>
                          <h3>质量方针</h3>
                          <dt><span style="white-space:normal;">保持公正 科学管理 诚实守信 致力高效</span></dt>
                      </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <FooterPage />
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted } from 'vue'
  // 组件逻辑
  import HeaderPage from '@/components/HeaderPage.vue'
  import FooterPage from '@/components/FooterPage.vue'


  let intervalId


  const stopAutoScroll = () => {
    clearInterval(intervalId)
  }

  onMounted(() => {

    // ✅ 滚动动画逻辑
    const elements = document.querySelectorAll('.wow')
    const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
    elements.forEach((el) => observer.observe(el))
    onUnmounted(() => {
      elements.forEach((el) => observer.unobserve(el))
      stopAutoScroll()
    })
  })
</script>

<style scoped>
.neiBanner {
  height: 640px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background:url('@/assets/images/culture.png');
}
.neiBanner .textBanner {
  color: #fff;
  text-align: center;
  font-weight: bold;
}
.neiBanner .textBanner dl {
  font-size: 72px;
}
.neiBanner .textBanner dt {
  font-size: 30px;
  font-weight: 500;
}
.culture {
  padding: 80px 0 150px;
}
.ntitle {
  text-align: center;
  margin-bottom: 50px;
}
.ntitle h3 {
  font-size: 38px;
  line-height: 1;
  color: #003366;
  font-weight: 500;
  border-bottom: #003366 solid 1px;
  display: inline-block;
  padding: 0 0 15px;
  margin-bottom: 15px;
}
.ntitle h2 {
  font-size: 36px;
  line-height: 1;
  color: #333;
  font-weight: 500;
}
.culture .box {
  padding: 65px;
  background: #f1f1f1;
}
.culture .box .pic,
.culture .box .textBox {
  width: 50%;
}
.culture .box .textBox ul {
  overflow: hidden;
}
.culture .box .textBox ul li {
  padding: 50px 0;
  border-top: 2px solid #023c6d;
  margin-top: -2px;
}
.culture .box .textBox ul li h3 {
  font-size: 36px;
  color: #023c6d;
  font-weight: 500;
}
.culture .box .textBox ul li dt {
  font-size: 24px;
}
</style>
